import { fetchReducerFactory } from '../../shared/store/fetchFactory';
import {
  FETCH_COUNTRY_TAX_TYPES,
  FETCH_COUNTRY_TAX_TYPES_SUCCESS,
  FETCH_COUNTRY_TAX_TYPES_FAILURE,
  SELECT_COUNTRY_TAX_TYPE,
  FETCH_TAX_ENTRIES,
  FETCH_TAX_ENTRIES_SUCCESS,
  RESET_TAX_ENTRIES,
  FETCH_TAX_ENTRY_DATA_SUCCESS,
  SHOW_ADD_ENTRY_MODAL,
  HIDE_ADD_ENTRY_MODAL,
  FETCH_SUBLEDGER_TAX_ENTRIES_SUCCESS,
  FETCH_PROPOSED_JOURNALS,
  FETCH_PROPOSED_JOURNALS_SUCCESS,
  FETCH_PROPOSED_JOURNALS_FAILURE,
  FETCH_SUBLEDGER_GL_ACCOUNTS_SUCCESS,
  RESET_PROPOSED_JOURNALS,
  FETCH_TAX_ENTRIES_FOR_APPROVAL,
  FETCH_TAX_ENTRIES_FOR_APPROVAL_SUCCESS,
  UNLOCK_TAX_ENTRIES_FOR_APPROVAL,
  SELECT_PERIOD_FROM,
  SELECT_PERIOD_TO,
  FETCH_TAX_ENTRY_FOR_APPROVAL_DATA_SUCCESS,
  RESET_DATA_FOR_APPROVE_TAX_ENTRY_PAGE,
  RESET_TAX_ENTRY_FOR_APPROVAL_DATA,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  RESET_DATA_FOR_NOTIFICATIONS_PAGE,
  FETCH_PROPOSED_RECLASS_JOURNALS,
  FETCH_PROPOSED_RECLASS_JOURNALS_SUCCESS,
  FETCH_PROPOSED_RECLASS_JOURNALS_FAILURE,
  FETCH_TAX_ENTRIES_FOR_APPROVAL_FAILURE,
  FETCH_TAX_ENTRIES_FAILURE,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_DIAGNOSTICS,
  FETCH_DIAGNOSTICS_SUCCESS,
  FETCH_DIAGNOSTICS_FAILURE,
  REVIEW_TAX_ENTRIES,
  REVIEW_TAX_ENTRIES_SUCCESS,
  REVIEW_TAX_ENTRIES_FAILURE,
  FETCH_TAX_ENTRIES_TREE,
  REVIEW_TAX_ENTRIES_PROGRESS,
  REVIEW_TAX_ENTRIES_CANCELLED,
  SUBMIT_TAX_ENTRY,
  SUBMIT_TAX_ENTRY_SUCCESS,
  SUBMIT_TAX_ENTRY_FAILURE,
  FETCH_DEFERRED_TAX_RATE,
  FETCH_TYPE_DESCRIPTIONS,
  FETCH_ACTIVITY_DESCRIPTIONS,
  FETCH_OBLIGATION_RATES,
  FETCH_TBE_ERRORS,
} from './types';

import {
  FETCH_ACCOUNT_ACTIVITY,
  FETCH_ACCOUNT_ACTIVITY_SUCCESS,
  FETCH_ACCOUNT_ACTIVITY_FAILURE,
  RESET_DATA_FOR_ACCOUNT_ACTIVITY_PAGE,
} from '../viewAccountActivityPage/store/types';

import {
  UPLOAD_TAX_ENTRIES_TO_IMPORT,
  UPLOAD_TAX_ENTRIES_TO_IMPORT_SUCCESS,
  UPLOAD_TAX_ENTRIES_TO_IMPORT_FAILED,
  FETCH_TAX_ENTRY_TO_IMPORT_DATA_SUCCESS,
  SUBMIT_BATCH_TAX_ENTRIES,
  SUBMIT_BATCH_TAX_ENTRIES_SUCCESS,
  SUBMIT_BATCH_TAX_ENTRIES_FAILURE,
  RESET_DATA_FOR_BATCH_TAX_ENTRIES,
} from '../batchTaxEntriesPage/store/types';

import { LOGOUT_SUCCESS } from '../../userData/store/types';

import { FETCH_ACCOUNTS_SUCCESS } from '../../shared/store/types';

import initialState from './initialState';

const addTaxEntryPageReducer = fetchReducerFactory({
  [FETCH_TAX_ENTRIES_TREE]: 'TaxEntriesTree',
  [FETCH_DEFERRED_TAX_RATE]: 'DeferredTaxRate',
  [FETCH_OBLIGATION_RATES]: 'ObligationRates',
  [FETCH_TYPE_DESCRIPTIONS]: 'TypeDescriptions',
  [FETCH_ACTIVITY_DESCRIPTIONS]: 'ActivityDescriptions',
  [FETCH_TBE_ERRORS]: 'TbeErrors',
}, initialState);

function balanceSheetManagementReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COUNTRY_TAX_TYPES:
      return {
        ...state,
        isLoadingCountryTaxTypes: true,
      };
    case FETCH_COUNTRY_TAX_TYPES_SUCCESS:
      return {
        ...state,
        countryTaxType: action.countryTaxType,
        countryTaxTypes: action.countryTaxTypes,
        isLoadingCountryTaxTypes: false,
      };
    case FETCH_COUNTRY_TAX_TYPES_FAILURE:
      return {
        ...state,
        isLoadingCountryTaxTypes: false,
      };
    case SELECT_COUNTRY_TAX_TYPE:
      return {
        ...state,
        countryTaxType: action.countryTaxType,
      };
    case FETCH_TAX_ENTRIES:
      return {
        ...state,
        taxEntriesLoading: true,
      };
    case FETCH_TAX_ENTRIES_SUCCESS:
      return {
        ...state,
        taxEntries: action.taxEntries,
        taxEntriesLoading: false,
        taxEntryData: {
          ...initialState.taxEntryData,
        },
        taxEntryId: initialState.taxEntryId,
      };
    case FETCH_TAX_ENTRIES_FAILURE:
      return {
        ...state,
        taxEntriesLoading: false,
      };
    case RESET_TAX_ENTRIES:
      return {
        ...state,
        taxEntries: initialState.taxEntries,
        taxEntryData: {
          ...initialState.taxEntryData,
        },
        taxEntryId: initialState.taxEntryId,
      };
    case FETCH_TAX_ENTRY_DATA_SUCCESS:
      return {
        ...state,
        taxEntryData: action.taxEntryData,
        taxEntryId: action.taxEntryId,
      };
    case SHOW_ADD_ENTRY_MODAL:
      return {
        ...state,
        showAddEntryModal: true,
      };
    case HIDE_ADD_ENTRY_MODAL:
      return {
        ...state,
        showAddEntryModal: false,
      };
    case FETCH_SUBLEDGER_TAX_ENTRIES_SUCCESS:
      return {
        ...state,
        subledgerTaxEntries: action.subledgerTaxEntries,
      };
    case FETCH_PROPOSED_JOURNALS:
      return {
        ...state,
        fetchingProposedJournals: true,
      };
    case FETCH_PROPOSED_JOURNALS_SUCCESS:
      return {
        ...state,
        proposedJournals: action.proposedJournals,
        fetchingProposedJournals: false,
      };
    case FETCH_PROPOSED_JOURNALS_FAILURE:
      return {
        ...state,
        fetchingProposedJournals: false,
      };
    case RESET_PROPOSED_JOURNALS:
      return {
        ...state,
        proposedJournals: initialState.proposedJournals,
        proposedJournalsForReclass: initialState.proposedJournalsForReclass,
      };
    case FETCH_PROPOSED_RECLASS_JOURNALS:
      return {
        ...state,
        fetchingProposedReclassJournals: true,
      };
    case FETCH_PROPOSED_RECLASS_JOURNALS_SUCCESS:
      return {
        ...state,
        proposedJournalsForReclass: action.proposedJournals,
        fetchingProposedReclassJournals: false,
      };
    case FETCH_PROPOSED_RECLASS_JOURNALS_FAILURE:
      return {
        ...state,
        fetchingProposedReclassJournals: false,
      };
    case FETCH_SUBLEDGER_GL_ACCOUNTS_SUCCESS:
      return {
        ...state,
        subledgerGlAccounts: action.subledgerGlAccounts,
      };
    case FETCH_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: action.accounts,
      };
    case FETCH_TAX_ENTRIES_FOR_APPROVAL:
      return {
        ...state,
        taxEntriesForApprovalLoading: true,
      };
    case FETCH_TAX_ENTRIES_FOR_APPROVAL_SUCCESS:
      return {
        ...state,
        taxEntriesForApprovalLoading: false,
        taxEntriesForApproval: action.taxEntriesForApproval,
        lockIdForTaxEntriesBatch: action.lockId,
      };
    case FETCH_TAX_ENTRIES_FOR_APPROVAL_FAILURE:
      return {
        ...state,
        taxEntriesForApprovalLoading: false,
      };
    case REVIEW_TAX_ENTRIES:
      if (action.reviewType === 'approve') {
        return {
          ...state,
          taxEntriesForApprovalLoading: true,
          taxEntriesReviewInProgress: true,
          taxEntriesDeclineInProgress: false,
        };
      }
      if (action.reviewType === 'decline') {
        return {
          ...state,
          taxEntriesForApprovalLoading: true,
          taxEntriesReviewInProgress: false,
          taxEntriesDeclineInProgress: true,
        };
      }
      break;
    case REVIEW_TAX_ENTRIES_PROGRESS:
      return {
        ...state,
        taxEntriesReviewProgress: action.progress,
      };
    case REVIEW_TAX_ENTRIES_SUCCESS:
    case REVIEW_TAX_ENTRIES_CANCELLED:
    case REVIEW_TAX_ENTRIES_FAILURE:
      return {
        ...state,
        taxEntriesReviewInProgress: false,
        taxEntriesDeclineInProgress: false,
        taxEntriesReviewProgress: 0,
      };
    case RESET_DATA_FOR_APPROVE_TAX_ENTRY_PAGE:
      return {
        ...state,
        taxEntriesForApproval: initialState.taxEntriesForApproval,
        taxEntryForApprovalData: initialState.taxEntryForApprovalData,
      };
    case RESET_TAX_ENTRY_FOR_APPROVAL_DATA:
      return {
        ...state,
        taxEntryForApprovalData: initialState.taxEntryForApprovalData,
      };
    case FETCH_TAX_ENTRY_FOR_APPROVAL_DATA_SUCCESS:
      return {
        ...state,
        taxEntryForApprovalData: {
          attachments: action.taxEntryData.attachments,
          taxEntryId: action.taxEntryData.taxEntryId,
        },
      };
    case UNLOCK_TAX_ENTRIES_FOR_APPROVAL:
      return {
        ...state,
        lockIdForTaxEntriesBatch: initialState.lockIdForTaxEntriesBatch,
      };
    case SELECT_PERIOD_FROM:
      return {
        ...state,
        taxPeriods: {
          ...state.taxPeriods,
          periodFrom: action.periodFrom,
        },
      };
    case SELECT_PERIOD_TO:
      return {
        ...state,
        taxPeriods: {
          ...state.taxPeriods,
          periodTo: action.periodTo,
        },
      };
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        notificationsLoading: true,
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
        notificationsLoading: false,
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notificationsLoading: false,
      };
    case FETCH_ACCOUNT_ACTIVITY:
      return {
        ...state,
        accountActivity: {
          ...state.accountActivity,
          accountActivityLoading: true,
        },
      };
    case FETCH_ACCOUNT_ACTIVITY_SUCCESS:
      return {
        ...state,
        accountActivity: {
          ...state.accountActivity,
          accountActivityLoading: false,
          accountActivityCollection: action.accountActivity,
        },
      };
    case FETCH_ACCOUNT_ACTIVITY_FAILURE:
      return {
        ...state,
        accountActivity: {
          ...state.accountActivity,
          accountActivityLoading: false,
        },
      };
    case RESET_DATA_FOR_NOTIFICATIONS_PAGE:
      return {
        ...state,
        notifications: null,
      };
    case UPLOAD_TAX_ENTRIES_TO_IMPORT:
      return {
        ...state,
        batchTaxEntries: {
          ...state.batchTaxEntries,
          isUploadingTaxEntriesToImport: true,
          insertedTaxEntries: initialState.batchTaxEntries.insertedTaxEntries,
          taxEntriesToImport: initialState.batchTaxEntries.taxEntriesToImport,
        },
      };
    case UPLOAD_TAX_ENTRIES_TO_IMPORT_SUCCESS:
      return {
        ...state,
        batchTaxEntries: {
          ...state.batchTaxEntries,
          isUploadingTaxEntriesToImport: false,
          taxEntriesToImport: action.taxEntriesToImport,
        },
      };
    case UPLOAD_TAX_ENTRIES_TO_IMPORT_FAILED:
      return {
        ...state,
        batchTaxEntries: {
          ...state.batchTaxEntries,
          isUploadingTaxEntriesToImport: false,
          taxEntriesToImport: initialState.batchTaxEntries.taxEntriesToImport,
        },
      };
    case FETCH_TAX_ENTRY_TO_IMPORT_DATA_SUCCESS:
      return {
        ...state,
        batchTaxEntries: {
          ...state.batchTaxEntries,
          chosenTaxEntry: action.chosenTaxEntry,
        },
      };
    case SUBMIT_BATCH_TAX_ENTRIES:
      return {
        ...state,
        batchTaxEntries: {
          ...state.batchTaxEntries,
          taxEntriesLoading: true,
        },
      };
    case SUBMIT_BATCH_TAX_ENTRIES_SUCCESS:
      return {
        ...state,
        batchTaxEntries: {
          ...initialState.batchTaxEntries,
          taxEntriesLoading: false,
          taxEntriesValidationTree: state.batchTaxEntries.taxEntriesValidationTree,
          insertedTaxEntries: action.insertedTaxEntries,
        },
      };
    case SUBMIT_BATCH_TAX_ENTRIES_FAILURE:
      return {
        ...state,
        batchTaxEntries: {
          ...state.batchTaxEntries,
          taxEntriesLoading: false,
        },
      };
    case RESET_DATA_FOR_BATCH_TAX_ENTRIES:
      return {
        ...state,
        batchTaxEntries: initialState.batchTaxEntries,
      };
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };
    case FETCH_DIAGNOSTICS:
      return {
        ...state,
        diagnosticsLoading: true,
      };
    case FETCH_DIAGNOSTICS_SUCCESS:
      return {
        ...state,
        diagnostics: action.diagnostics,
        diagnosticsLoading: false,
      };
    case FETCH_DIAGNOSTICS_FAILURE:
      return {
        ...state,
        diagnosticsLoading: false,
      };
    case SUBMIT_TAX_ENTRY:
      return {
        ...state,
        submittingTaxEntry: true,
      };
    case SUBMIT_TAX_ENTRY_SUCCESS:
    case SUBMIT_TAX_ENTRY_FAILURE:
      return {
        ...state,
        submittingTaxEntry: false,
      };
    case RESET_DATA_FOR_ACCOUNT_ACTIVITY_PAGE:
      return {
        ...state,
        accountActivity: {
          ...initialState.accountActivity,
        },
      };
    default:
      return addTaxEntryPageReducer(state, action);
  }
}

export default balanceSheetManagementReducer;
